import { Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";

//Admin routes
import Home from "./pages/homePage/Home";
import AdminLogin from "./pages/loginPage/AdminLogin";
import MasterEntery from "./pages/masterEntery/MasterEntry";
//nested
import Batch from "./Components/masterEntry/Batch";
import Category from "./Components/masterEntry/Category";
import Group from "./Components/masterEntry/Group";
import Units from "./Components/masterEntry/Units";
import Brand from "./Components/masterEntry/Brand";
import HSN from "./Components/masterEntry/HSN";
import Item from "./Components/masterEntry/Item";
import Dashboard from "./pages/dashboardPage/Dashboard";
import Loader from "./Components/Loader/Loader";
import Profile from "./pages/Profile/Profile";
import Configuration from "./pages/Configuration/Configuration";
import Customers from "./pages/Customers/Customers";
import Supplier from "./pages/Supplier/Supplier";
import AccountMaster from "./pages/AccountMaster/AccountMaster";
import Transaction from "./pages/Transaction/Transaction";
//nested
import DebitNote from "./pages/Transaction/DebitNote/DebitNote";
import PurchaseBill from "./pages/Transaction/PurchaseBill/PurchaseBill";
import PurchaseOrder from "./pages/Transaction/PurchaseOrder/PurchaseOrder";
import OutstandingReport from "./pages/Transaction/OutstandingReport/OutstandingReport";
import CreateReceipts from "./pages/Transaction/CreateReceipts/CreateReceipts";
import Invoice from "./pages/Invoice/Invoice";
import SalesOrder from "./pages/SalesOrder/SalesOrder";
import ItemAdvance from "./Components/masterEntry/ItemEditOptions/ItemAdvance";
import Location from "./pages/Location/Location";
import Subscription from "./pages/Subscription/Subscription";
import SubscriptionOrder from "./pages/Subscription/SubscriptionOrder";
import SubscriptionDispatch from "./pages/Subscription/SubscriptionDispatch";
import Catalog from "./pages/Catalog/Catalog";
import LocationAdvance from "./pages/Location/LocationAdvance/LocationAdvance";
import Welcome from "./pages/Welcome/Welcome";
import SuperCategory from "./pages/SuperCategory/SuperCategory";
import AdminPay from "./pages/Transaction/OutstandingReport/AdminPay";
import CityMaster from "./pages/CityMaster/CityMaster";
import Registration from "./pages/Registration/Registration";
import AccessMaster from "./pages/AccessMaster/AccessMaster";
import ProductInfo from "./pages/ProductInfo/ProductInfo";
import PaymentAndReceipt from "./pages/Transaction/Voucher/Voucher";
import UnregisterPayment from "./pages/UnregisterPayment/UnregisterPayment";
import NotFound from "./Components/NotFound/NotFound";
import Dispatch from "./pages/Dispatch/Dispatch";
import AdminLayout from "./Layout/AdminLayout";
import JournalEntry from "./pages/Transaction/JournalEntry/JournalEntry";
import AdminReport from "./pages/Report/AdminReport";
import GstInvoiceReport from "./Components/report/GstInvoiceReport";
import RegistrationForm from "./pages/RegistrationForm/RegistrationForm";
import GstTransactionReport from "./Components/report/GstTransactionReport";
import AccountMasterEntry from "./pages/masterEntery/AccountMasterEntry";
import StockUpdate from "./Components/Card/MaterEntryCards/StockUpdate";
import SideBarRedesign from "./Components/sidebar/SideBarRedesign";
import SalesReport from "./Components/report/SalesReport/SalesReport";
import SalesSummaryReport from "./Components/report/SalesReport/SalesSummaryReport";
import SalesSummary from "./Components/report/SalesReport/SalesSummary";
import UserLayout from "./Layout/CustomerLayout/UserLayout";
import AllLedgersReport from "./pages/Report/allLedgersReport/AllLedgersReport";

//Customer Routes
import CustDashboard from "./Customer/Pages/CustDashboard/CustDashboard";
import CustInvoice from "./Customer/Pages/CustInvoice/CustInvoice";
import CustProfile from "./Customer/Pages/CustProfile/CustProfile";
import CustChangePassword from "./Customer/Pages/CustChangePassword/CustChangePassword";
import CustSalesSubscription from "./Customer/Pages/CustSalesSubscription/CustSalesSubscription";
import CustPayment from "./Customer/Pages/CustPayment/CustPayment";
import ForgetPassword from "./pages/ForgetPassword/ForgetPassword";
import Notify from "./Customer/Pages/Notify/Notify";
import Product from "./Customer/Pages/Product/Product";
import CustCart from "./Customer/Pages/CustCart/CustCart";
import ProductDetails from "./Customer/Pages/Product/ProductDetails";
import CustPurchaseOrder from "./Customer/Pages/CustPurchaseOrder/CustPurchaseOrder";
import Pay from "./Customer/Pages/CustPayment/Pay";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import UserHistoryTable from "./pages/UserHistory/UserHistoryTable";
import OutstandingTable from "./Customer/Pages/Outstanding Report/OutstandingTable";
import TrialBalanceReport from "./Components/report/trialBalance/TrialBalanceReport";
import LeadsPage from "./pages/leads/LeadsPage";
import MenuPage from "./pages/Menu/MenuPage";
import PermissionsTable from "./Components/AccessMaster/PermissionsTable";
// import QRBarcodeScanner from "./Components/QRBarcodeScanner/QRBarcodeScanner";
import NotAuthorized from "./Components/MiddlewareAdminRoutes/NotAuthorized";
import ProtectedRoute from "./Components/MiddlewareAdminRoutes/ProtectedRoute";
import CreditNote from "./pages/creditNote/CreditNote";
import SalesCancelReportTable from "./Components/report/SalesReport/SalesCancelReportTable";
import InvoiceCancelReportTable from "./Components/report/SalesReport/InvoiceCancelReportTable";
import EmailConfigurationPage from "./pages/EmailConfiguration/EmailConfigurationPage";
import InventoryTransformationCard from "./pages/InventryTransformation/InventoryTransformationCard";
import EcommerceRoutes from "./pages/Ecommerce/Coupon/EcommerceRoutes";
import CouponsCard from "./pages/Ecommerce/Coupon/CouponsCard";
import PaymentPage from "./pages/Ecommerce/PaymentGatwayConfiguration/PaymentPage";
import PaymentLog from "./pages/Ecommerce/PaymentGatwayConfiguration/PaymentLog";
import GoodsTransfer from "./pages/GoodsTransfer/GoodsTransfer";
import TransferPage from "./pages/GoodsTransfer/TransferPage";
import ChallanPage from "./pages/ChallanPage/ChallanPage";
import ChallanReport from "./pages/ChallanPage/ChallanReport";
import SiteTransferReport from "./pages/ChallanPage/SiteTransferReport";
import CustomerItemReport from "./pages/ChallanPage/CustomerItemReport";

//FUNCTION
function App() {
  const isLoaderActive = useSelector((state) => state.loader.isLoaderActive);

  return (
    <>
      <Toaster />
      {isLoaderActive && <Loader />}

      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/Registration-Form" element={<RegistrationForm />} />
        <Route path="/Siderbarredisgn" element={<SideBarRedesign />} />
        //#region ADMIN ROUTES
        {/* ADMIN ROUTES Begin */}
        <Route path="/admin-login" element={<AdminLogin />} />
        {/* <Route path='/register' element={<Register />} /> */}
        <Route path="/forgetPassword" element={<ForgetPassword />} />
        <Route element={<AdminLayout />}>
          {/* <Route path="/dashboard" element={<Dashboard />} /> */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute requiredPermission={48}>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/master-entry" element={<MasterEntery />}>
            <Route
              path="batch"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <Batch />
                </ProtectedRoute>
              }
            />
            <Route
              path="category"
              element={
                <ProtectedRoute requiredPermission={65}>
                  <Category />
                </ProtectedRoute>
              }
            />
            <Route
              path="group"
              element={
                <ProtectedRoute requiredPermission={66}>
                  <Group />
                </ProtectedRoute>
              }
            />
            <Route
              path="units"
              element={
                <ProtectedRoute requiredPermission={67}>
                  <Units />
                </ProtectedRoute>
              }
            />
            <Route
              path="brand"
              element={
                <ProtectedRoute requiredPermission={64}>
                  <Brand />
                </ProtectedRoute>
              }
            />
            <Route
              path="goods-transfer-page"
              element={
                <ProtectedRoute requiredPermission={72}>
                  <TransferPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="hsn"
              element={
                <ProtectedRoute requiredPermission={68}>
                  <HSN />
                </ProtectedRoute>
              }
            />
            <Route
              path="item"
              element={
                <ProtectedRoute requiredPermission={24}>
                  <Item />
                </ProtectedRoute>
              }
            />
            <Route
              path="item/advance"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <ItemAdvance />
                </ProtectedRoute>
              }
            />
            <Route
              path="super-category"
              element={
                <ProtectedRoute requiredPermission={69}>
                  <SuperCategory />
                </ProtectedRoute>
              }
            />
            <Route
              path="location"
              element={
                <ProtectedRoute requiredPermission={70}>
                  <Location />
                </ProtectedRoute>
              }
            />
            <Route
              path="inventory/transformation"
              element={
                <ProtectedRoute requiredPermission={53}>
                  <InventoryTransformationCard />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route
            path="/invoice"
            element={
              <ProtectedRoute requiredPermission={2}>
                <Invoice />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales-order"
            element={
              <ProtectedRoute requiredPermission={9}>
                <SalesOrder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/challan-order"
            element={
              <ProtectedRoute requiredPermission={61}>
                <ChallanPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscriptions"
            element={
              <ProtectedRoute requiredPermission={0}>
                <Subscription />
              </ProtectedRoute>
            }
          />

          <Route path="/account-master-entry" element={<AccountMasterEntry />}>
            <Route
              path="account-master"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <AccountMaster />
                </ProtectedRoute>
              }
            />
            <Route
              path="customers"
              element={
                <ProtectedRoute requiredPermission={18}>
                  <Customers />
                </ProtectedRoute>
              }
            />
            <Route
              path="leads"
              element={
                <ProtectedRoute requiredPermission={42}>
                  <LeadsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="supplier"
              element={
                <ProtectedRoute requiredPermission={45}>
                  <Supplier />
                </ProtectedRoute>
              }
            />
            {/* <Route path="permission-table" element={<PermissionsTable />} /> */}
          </Route>

          <Route path="/transaction" element={<Transaction />}>
            <Route
              path="create-vouchers"
              element={
                <ProtectedRoute requiredPermission={27}>
                  <PaymentAndReceipt />
                </ProtectedRoute>
              }
            />
            <Route
              path="journal-entry"
              element={
                <ProtectedRoute requiredPermission={30}>
                  <JournalEntry />
                </ProtectedRoute>
              }
            />
            <Route
              path="debit-note"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <DebitNote />
                </ProtectedRoute>
              }
            />
            <Route
              path="credit-note"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <CreditNote />
                </ProtectedRoute>
              }
            />
            <Route
              path="purchase-bill"
              element={
                <ProtectedRoute requiredPermission={36}>
                  <PurchaseBill />
                </ProtectedRoute>
              }
            />
            <Route
              path="purchase-order"
              element={
                <ProtectedRoute requiredPermission={33}>
                  <PurchaseOrder />
                </ProtectedRoute>
              }
            />
            <Route
              path="create-receipts"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <CreateReceipts />
                </ProtectedRoute>
              }
            />
            <Route
              path="stockUpdate"
              element={
                <ProtectedRoute requiredPermission={73}>
                  <StockUpdate />
                </ProtectedRoute>
              }
            />
            <Route
              path="dispatch"
              element={
                <ProtectedRoute requiredPermission={39}>
                  <Dispatch />
                </ProtectedRoute>
              }
            />
            <Route
              path="Gst-transaction-report"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <GstTransactionReport />
                </ProtectedRoute>
              }
            />


          </Route>

          <Route path="/report" element={<AdminReport />}>
            <Route
              path="outstanding-report"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <OutstandingReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="gst-invoice-report"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <GstInvoiceReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="sales-report"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <SalesReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="sales-summary-report"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <SalesSummaryReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="sales-summary"
              element={
                <ProtectedRoute requiredPermission={56}>
                  <SalesSummary />
                </ProtectedRoute>
              }
            />
            <Route
              path="trial-balance-report"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <TrialBalanceReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="all-ledgers"
              element={
                <ProtectedRoute requiredPermission={57}>
                  <AllLedgersReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="user-log-history"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <UserHistoryTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="sales-cancel-report-table"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <SalesCancelReportTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="invoice-cancel-report-table"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <InvoiceCancelReportTable />
                </ProtectedRoute>
              }
            />
            <Route
              path="challan-report"
              element={
                <ProtectedRoute requiredPermission={58}>
                  <ChallanReport />
                </ProtectedRoute>
              }
            />

            <Route
              path="site-trnsfer-report"
              element={
                <ProtectedRoute requiredPermission={59}>
                  <SiteTransferReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="customer-item-report"
              element={
                <ProtectedRoute requiredPermission={60}>
                  <CustomerItemReport />
                </ProtectedRoute>
              }
            />

          </Route>

          <Route
            path="/register-company"
            element={
              <ProtectedRoute requiredPermission={0}>
                <Registration />
              </ProtectedRoute>
            }
          />
          <Route
            path="/configuration"
            element={
              <ProtectedRoute requiredPermission={0}>
                <Configuration />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={

              <Profile />

            }
          />
          <Route
            path="/access-master"
            element={
              <ProtectedRoute requiredPermission={74}>
                <AccessMaster />
              </ProtectedRoute>
            }
          />

          <Route
            path="/subscription"
            element={
              <ProtectedRoute requiredPermission={0}>
                <Subscription />
              </ProtectedRoute>
            }
          />

          <Route
            path="/subscriptions-order"
            element={
              <ProtectedRoute requiredPermission={0}>
                <SubscriptionOrder />
              </ProtectedRoute>
            }
          />

          <Route
            path="/subscriptions-dispatch"
            element={
              <ProtectedRoute requiredPermission={0}>
                <SubscriptionDispatch />
              </ProtectedRoute>
            }
          />

          <Route
            path="/unregister-payment"
            element={
              <ProtectedRoute requiredPermission={0}>
                <UnregisterPayment />
              </ProtectedRoute>
            }
          />

          <Route
            path="/change-password"
            element={
              <ProtectedRoute requiredPermission={0}>
                <ChangePassword />
              </ProtectedRoute>
            }
          />

          <Route
            path="/Create-menu"
            element={
              <ProtectedRoute requiredPermission={75}>
                <MenuPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/email/configuration"
            element={
              <ProtectedRoute requiredPermission={0}>
                <EmailConfigurationPage />
              </ProtectedRoute>
            }
          />

          {/* <Route path="/accessMaster" element={<AccessMaster />} />
        <Route path="/updateProduct" element={<UpdateProduct />} /> */}

          {/* <Route path="/report" element={<Report />}>
          <Route path="srs" element={<SRS />} />
          <Route path="sri" element={<SRI />} />
          <Route path="customer-report" element={<CustomerReport />} />
          <Route path="order-report" element={<OrderReport />} />
          <Route path="purchase-report" element={<PurchaseReport />} />
        </Route> */}

          <Route path="/e-commerce" element={<EcommerceRoutes />}>
            <Route path="coupon_rules" element={<CouponsCard />} />
            <Route path="payment-configuration" element={<PaymentPage />} />
            <Route path="payment/log" element={<PaymentLog />} />


            <Route
              path="catalog"
              element={
                <ProtectedRoute requiredPermission={0}>
                  <Catalog />
                </ProtectedRoute>
              }
            />
          </Route>
        </Route>
        {/* ADMIN ROUTES End */}
        //#endregion
        <Route path="/location/advance" element={<LocationAdvance />} />
        <Route
          path="/transaction/outstanding-report/pay"
          element={<AdminPay />}
        />
        <Route path="/city" element={<CityMaster />} />
        //#region CUSTOMER ROUTES
        {/* Customer Routes Begin */}
        <Route path="/" element={<Welcome />} />
        <Route path="/login" element={<Home />} />
        <Route element={<UserLayout />}>
          <Route path="/customer-dashboard" element={<CustDashboard />} />
          <Route path="/customer-invoice" element={<CustInvoice />} />
          <Route path="/product" element={<Product />} />
          <Route path="/product-details" element={<ProductDetails />} />
          <Route path="/Purchase-Order" element={<CustPurchaseOrder />} />
          <Route path="/customer-payment" element={<CustPayment />} />
          <Route path="/customer-payment/pay" element={<Pay />} />
          <Route path="/customer-profile" element={<CustProfile />} />
          <Route path="/cart" element={<CustCart />} />
          <Route
            path="/customer-sales-subscription"
            element={<CustSalesSubscription />}
          />
          <Route
            path="/customer-change-password"
            element={<CustChangePassword />}
          />
          <Route path="/customer-Notifications" element={<Notify />} />
          <Route
            path="/customer-outstanding-reports"
            element={<OutstandingTable />}
          />
        </Route>
        {/* Customer Routes End */}
        //#endregion
        {/* QR Routes */}
        <Route path="/product-info" element={<ProductInfo />} />
        {/* <Route path="/qr-code" element={<QRBarcodeScanner />} /> */}
        <Route path="/not-authorized" element={<NotAuthorized />} />
      </Routes>
    </>
  );
}

export default App;
